import { convertirLatLonGMS, latLonToEtrs89Utm, utmHemisphereFromLat, utmZoneFromLon } from "./ArcGIS";
import DateService, { FMT } from "./DateService";
import { getNombrePersonalGuardia } from "./GuardiasUIHelper";
import { sanitizeFileName } from "./Utils";
export const generateNamePDF = (fechaCreacion, esIncendio, nombreEmergencia, municipio) => {
    const fecha = DateService.toDayjs(fechaCreacion).format(FMT.fileName);
    const baseName = sanitizeFileName(nombreEmergencia || 'SIN_NOMBRE');
    const nombreClase = esIncendio ? 'Incendio' : 'Evento';
    return `${fecha}_${nombreClase}_${baseName}_${municipio}.pdf`;
};
export const formatCoordenadasGMS = (lat, lon) => {
    if (lat == null || lon == null)
        return '';
    const latStr = convertirLatLonGMS(lat, 'LATITUDE').valor;
    const lonStr = convertirLatLonGMS(lon, 'LONGITUDE').valor;
    return `${latStr}\n${lonStr}`;
};
export const generateFormatoDate = (rawFecha) => {
    if (!rawFecha)
        return '';
    return `${DateService.toDayjs(rawFecha, FMT.date).format(FMT.display)}h`;
};
export const getFechaRecursoEstado = (recursos, index, estadosPosibles) => {
    const estadoEsperado = estadosPosibles[index]?.NOMBRE;
    if (!estadoEsperado)
        return null;
    const recurso = recursos.find(r => r.RECURSO_SECTOR_ESTADO_TIPO.NOMBRE === estadoEsperado);
    return recurso?.FECHA ? DateService.toDayjs(recurso.FECHA) : null;
};
export const getFechaRecursoEstadoFormatted = (recursoSectorEstadoList, idEstadoSelected) => {
    const fecha = recursoSectorEstadoList.find(estado => estado.ID_RECURSO_SECTOR_ESTADO_TIPO === idEstadoSelected)?.FECHA;
    return fecha ? DateService.toDayjs(fecha).format(FMT.display) + 'h' : '';
};
export const getEstadosEmergenciaFormateados = (estadosPosibles, estadosEmergencia) => {
    const estadosNombre = estadosPosibles.map(estado => estado.EMERGENCIA_ESTADO);
    return estadosNombre.reduce((acc, estado) => {
        const encontrado = estadosEmergencia.find(e => e.EMERGENCIA_ESTADO_TIPO.EMERGENCIA_ESTADO === estado);
        acc[estado] = generateFormatoDate(encontrado?.FECHA ?? null);
        return acc;
    }, {});
};
export const getUltimaGravedadPotencialNombre = (gravedadesLista) => {
    const lista = gravedadesLista || [];
    if (!lista.length)
        return '0 - Bajo';
    return lista
        .slice()
        .sort((a, b) => DateService.toDayjs(b.FECHA).valueOf() - DateService.toDayjs(a.FECHA).valueOf())[0]
        .TIPO_GRAVEDAD_POTENCIAL.NOMBRE;
};
export const getRecursoPersonalNameById = (idRecurso, recursosEnIncendio) => {
    const recurso = recursosEnIncendio.find(r => r.ID_RECURSO === idRecurso);
    return recurso ? getNombrePersonalGuardia(recurso) : undefined;
};
export const getNivelMaximo = (nivelesEnEmergencia, nivelesPosibles) => {
    if (!nivelesEnEmergencia || nivelesEnEmergencia.length === 0)
        return 'Nivel 0';
    const nivelMax = nivelesEnEmergencia.reduce((max, current) => {
        const nivelObj = nivelesPosibles.find(n => n.VALUE === current.TIPO_EMERGENCIA_NIVEL.VALUE);
        if (!nivelObj)
            return max;
        return !max || (nivelObj.VALUE ?? 0) > (max.VALUE ?? 0) ? nivelObj : max;
    }, null);
    return nivelMax?.EMERGENCIA_NIVEL ?? 'Nivel 0';
};
export const getEsfuerzoExtincion = (recursosEstados, formateadoES = false) => {
    if (!recursosEstados?.length)
        return '0';
    // TODO: HAY QUE TENER CUIDADO, EL ORDEN CON NÚMERO 1, SE REFLEJA COMO TRUE
    const estadosPorOrden = Object.fromEntries(recursosEstados.map(r => {
        const orden = Number(r.RECURSO_SECTOR_ESTADO_TIPO.ORDEN) || 0;
        return [orden, DateService.toDayjs(r.FECHA)];
    }));
    const enIncendio = estadosPorOrden[3];
    const regreso = estadosPorOrden[6];
    const liquidacion = estadosPorOrden[4];
    const desasignado = estadosPorOrden[99];
    let diff = 0;
    if (enIncendio && regreso) {
        diff = regreso.diff(enIncendio, 'hour', true);
    }
    else if (regreso && liquidacion) {
        diff = regreso.diff(liquidacion, 'hour', true);
    }
    else if (!regreso && enIncendio && desasignado) {
        diff = desasignado.diff(enIncendio, 'hour', true);
    }
    const value = diff.toFixed(2);
    return formateadoES
        ? formatNumberES(+value)
        : value;
};
export const getTotalHoras = (recursosEstados, formateadoES = false) => {
    if (!recursosEstados?.length)
        return '0';
    // TODO: HAY QUE TENER CUIDADO, EL ORDEN CON NÚMERO 1, SE REFLEJA COMO TRUE
    const estadosPorOrden = Object.fromEntries(recursosEstados.map(r => {
        const orden = Number(r.RECURSO_SECTOR_ESTADO_TIPO.ORDEN) || 0;
        return [orden, DateService.toDayjs(r.FECHA)];
    }));
    const asignado = estadosPorOrden[1];
    const desasignado = estadosPorOrden[99];
    const diff = asignado && desasignado
        ? desasignado.diff(asignado, 'hour', true)
        : 0;
    const value = diff.toFixed(2);
    return formateadoES
        ? formatNumberES(+value)
        : value;
};
export const formatNumberES = (value, format = 'es-ES', decimals = 2, grouping = true, retunValueNum = false) => {
    if (!value)
        return retunValueNum ? '0,00' : '-';
    return value.toLocaleString(format, {
        useGrouping: grouping,
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
};
export const formatNumberCoord = (n) => {
    const v = Number(n);
    return Number.isFinite(v) ? Math.round(v) : '';
};
// Función para meter un salto de línea si el texto supera el límite de caracteres
export const wrapText = (text, maxLen) => {
    const words = text.split(" ");
    let line = "";
    const lines = [];
    words.forEach(word => {
        if ((line + word).length > maxLen) {
            lines.push(line.trim());
            line = word + " ";
        }
        else {
            line += word + " ";
        }
    });
    if (line)
        lines.push(line.trim());
    return lines.join("\n");
};
// Función para formatear las coordenadas UTM
export const formatUtmLabel = (lat, lon) => {
    if (!lat || !lon)
        return '';
    const zone = utmZoneFromLon(lon);
    const letterZone = utmHemisphereFromLat(lat);
    const [x, y] = latLonToEtrs89Utm(lat, lon, zone);
    return `Huso: ${zone}${letterZone}    X = ${formatNumberES(x, 'es-ES', 0, false)}    Y = ${formatNumberES(y, 'es-ES', 0, false)}`;
};
export const normalizeNumber = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};
